import './Motto.scss';

class Motto {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['Motto'] = Motto;
export default Motto;
